var OperationTypeEnum = {
    '1251': 'Ventas / Devoluciones',
    '1250': 'Ventas / Devoluciones',
    '1261': 'Reclamación',
    '1260': 'Reclamación',
    '1271': 'Cargo Boleta',
    '1270': 'Anu Cargo Boleta',
    '9991': 'MARKET PAY',
    '9990': 'MARKET PAY',
};

module.exports = OperationTypeEnum;


// WEBPACK FOOTER //
// ./src/enums/OperationTypeEnum.js